<template>
    <div class="app-inner" id="fzpaper">
         <div class="public-btn-div flex align-cen">
            <div class="public-add" @click="addRaso">
            新增仿真试卷 
      </div>
         </div>
          <div class="p-tit-c">
            <div class="businessList-filter">
                    <div class="businessList-filter-list flex align-cen">
                     <div class="fl-le flex align-cen">
          <div class="label">仿真试卷名称：</div>
          <div class="el-select1">
            <el-input placeholder="请输入试卷名称" v-model="search" clearable> </el-input>
          </div>
         </div>
          <div class="fl-rt flex align-cen">
          <div class="label">试卷ID：</div>
          <div class="el-select1">
          <el-input placeholder="请输入试卷ID" v-model="search1" clearable> </el-input>
          </div>
         </div>
            <div class="fl-rt flex align-cen">
          <div class="label">关联工况ID：</div>
          <div class="el-select1">
          <el-input placeholder="请输入关联工况ID" v-model="search2" clearable> </el-input>
          </div>
         </div>
              </div> 
              <div class="businessList-filter-list flex align-cen">
                  <div class="fl-le flex align-cen">
                      <div class="label">关联仿真应用：</div>
                        <el-select
                        v-model="value1"
                        clearable
                        placeholder="请选择"
                        @change="classSelect"
                    >
                        <el-option
                        v-for="item in options"
                          :key="item.id"
                        :label="item.appName === '未分类' ? '未分类' : item.appName"
                        :value="item.id"
                        >
            </el-option>
          </el-select>
                  </div>
              </div>
                 <!-- <div class="businessList-filter-list flex align-cen">
                        <div class="label">有效期限：</div>
                        <div
                        style="color: red; padding-right: 20px; cursor: pointer"
                        @click="allradio(0)"
                        >
                        不限
                        </div>
                        <el-radio v-model="radio" label="1" @change="classSelect" >有时间限制</el-radio>
                        <el-radio v-model="radio" label="2" @change="classSelect">无时间限制</el-radio>
                    </div> -->
                <div class="businessList-filter-list flex align-cen">
                    <div class="label">启用状态：</div>
                    <div
                    style="color: red; padding-right: 20px; cursor: pointer"
                    @click="allradio(1)"
                    >
                    不限
                    </div>
                    <el-radio v-model="radio1" label="1" @change="classSelect" >启用</el-radio>
                    <el-radio v-model="radio1" label="2" @change="classSelect">禁用</el-radio>
                </div>
                    <div class="businessList-filter-list flex align-cen public-btn-small">
        <div class="public-btn-small-primary" @click="classSelect">
        搜索
        </div>
        <div class="public-btn-small-text" @click="reset">
        重置筛选条件 
        </div>
      </div>
            </div>
          </div>
                <div class="businessList-container">
        <div class="businessList-container-table">
                  <el-table
            :data="list"
            border
            style="width: 100%"
            :header-cell-style="{background:'#f7f8fa',color:'#333'}"
            >
                <el-table-column label="试卷封面" align="center" prop="pic"  width="200">
            <template slot-scope="scope" >
                <img :src="scope.row.logo ? scope.row.logo : require('../../../assets/images/nullimg.png')" alt="" style="display: block;width:50%;margin:0 auto" v-if="scope.row.id !=0"> 
            </template>
         </el-table-column>
          <el-table-column prop="id" label="试卷ID" align="center" width="200">
          </el-table-column>
          <el-table-column prop="paperName" label="试卷名称" align="center" width="300">
          </el-table-column>
              <el-table-column prop="" label="关联仿真应用" align="center" width="300">
             <template slot-scope="scope">
              <div>
                {{scope.row.appName || '-'}}
              </div>
             </template>
          </el-table-column>
            <el-table-column prop="" label="关联工况ID" align="center" width="200">
             <template slot-scope="scope">
              <div>
                {{scope.row.omId || '-'}}
              </div>
             </template>
          </el-table-column>
           <el-table-column prop="examNum" label="考试人次" align="center" width="150">
          </el-table-column>
           <el-table-column prop="" label="考试时间" align="center" >
             <template slot-scope="scope">
              <div>
                {{scope.row.answerTimeLimit ? `${scope.row.answerTimeLimit}分钟` : '-'}}
              </div>
             </template>
          </el-table-column>
           <el-table-column prop="processNum" label="过程数" align="center" width="150">
          </el-table-column>
            <el-table-column prop="stepNum" label="步骤数" align="center"  width="150">
          </el-table-column>
            <el-table-column label="启用状态" align="center" width="150">
            <template slot-scope="scope">
              <div class="buStatus"  @click="changeStatus(scope)">
                <el-switch
                  v-model="scope.row.state == 2 ? false : true"
                  disabled
                >
                </el-switch>
              </div>
            </template>
          </el-table-column>
            <el-table-column
            fixed="right"
            label="操作"
            align="center"
            width="250"
            >
             <template slot-scope="scope">
                  <el-button type="text" size="small"  slot="reference" style="color:red" @click="openscoreAnalysis(scope.row)">统计分析</el-button>
                   <el-button type="text" size="small"  slot="reference" style="color:red" @click="addRaso(scope.row)">编辑试卷</el-button>
                    <el-button type="text" size="small"  slot="reference" style="color:red" @click="openmoniToring(scope.row)">考试监控</el-button>
                      <el-button type="text" size="small"  slot="reference" style="color:red" @click="deleteEmPaper(scope.row)">删除</el-button>
             </template>
          </el-table-column>
        </el-table>
                   <paginaTion :total="totalCount" @sendStatus="emitFun"></paginaTion>
        </div>
                </div>
    </div>
</template>
<script>
import {getEmuPaper,helpAppList,editEmuPaper,deleteEmuPaperl} from "@/api/index/index"   //分页查询仿真试卷、关联仿真应用、修改试卷、删除仿真试卷
import paginaTion from "@/components/paginaTion/index.vue"; //分页组件
export default {
    data () {
        return {
            options:[],
            search:'',
            search1:'',
            search2:'',
            value1:'',
            options:[],
            radio:'',
            radio1:'',
            list:[],
            totalCount:0,
            currentPage: 1, //初始页
            PageSize: 10, //每页的数据
        }
    },
    components:{
      paginaTion
    },
    activated(){
        this.getEmuPaperList()
    },
    created() {
        this.getApplist()
    },
    methods: {
      // 删除仿真试卷
      deleteEmPaper(data){
         this.$confirm('您确定要删除该试卷吗？删除后该试卷考试记录也会被删除，请您谨慎操作', '删除试卷', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
              }).then(() => {
                  deleteEmuPaperl({id:data.id},'DELETE')
                  .then(res =>{
                    if(res.code == 0){
                      this.$util.Notifi('删除成功','success','fa-check')
                   this.getEmuPaperList()
                    }else{
                      this.$util.Notifi(res.msg,'error','fa-exclamation-circle');
                    }
                  })
              }).catch(() => {          
              });
      },
         // 打开考试监控
      openmoniToring(data){
        this.$router.push({
            name: "rasoMoniToring",
            query:{
                id:data.id,
            }
           })
      },
           // 打开统计分析
      openscoreAnalysis(data){
        this.$router.push({
            name: "rasoAnalysis",
            query:{
                id:data.id,
            }
           })
      },
        // 关联仿真应用
          getApplist(){
            helpAppList({
              parentClassifyId:2
              })
            .then(res => {
              this.options = res.data
            })
            .catch(err => {
            })
        },
        // 仿真试卷
        addRaso(data){
            data.id ? this.$router.push({name:'addRaso',query:{id:data.id}}) : this.$router.push({name:'addRaso',query:{}})
        },
             // 筛选
        classSelect(){
            this.currentPage = 1 
            this.getEmuPaperList()
        },
        reset(){
             this.search=""
          this.search1=""
           this.search2=""
          this.value1=""
          this.radio1=""
          this.radio=""
          this.currentPage=1
          this.getEmuPaperList()
        },
              emitFun(val,val1){
        if(val1 == "PageSize") this.PageSize = val
       if(val1 == "currentPage") this.currentPage = val
       this.getEmuPaperList()
      },
      allradio(type){
          type == 1 ? this.radio1="" : this.radio=""
          this.currentPage=1
          this.getEmuPaperList()
        },
               // 应用状态改变
    changeStatus(e){
     if(e.row.state == 1){
           this.$confirm('确认关闭吗？', '试卷禁用', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                        }).then(() => {
                        this.editPaper(e)
                        }).catch(() => {          
                        });
        }else{
            this.editPaper(e)
        }
      },
       editPaper(e){
             editEmuPaper({
                id:e.row.id,
                state:e.row.state == 1 ? '2' : '1',
                    },'put')
                .then(res => {
                  if(res.code ==1){
                     this.$message.error(res.msg); 
                  }else{
                      this.$message.success('状态修改成功'); 
                    this.getEmuPaperList()
                  }
                })
                .catch(err => {
                })
        },
        // 获取仿真分页列表
        getEmuPaperList(){
            let params = {
                paperName:this.search,
                id:this.search1,
                appId:this.value1,
                omId:this.search2,
                validPeriod:this.radio,
                state:this.radio1,
                 current: this.currentPage,
                size:this.PageSize,
            }
            getEmuPaper(params)
            .then(res =>{
            this.list = res.data.records
             this.totalCount = res.data.total;
            })
            .catch(err =>{})
        },

    }
}
</script>
<style lang="scss" scoped>
  .businessList-container {
    .businessList-container-table {
      margin-top: 20px;
      .el-switch {
        position: relative;
        z-index: 1 !important;
      }
      .el-switch.is-disabled {
        opacity: 1 !important;
      }
      .buStatus{
        width: 50px;
        margin: 0 auto;
      }
    }
    .jiange {
      margin-top: 20px;
    }
  }
    ::v-deep {
  .el-switch.is-disabled .el-switch__core {
    cursor: pointer !important;
    width: 50px !important;
  }
}
</style>